import { Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { BindQueryParamsFactory } from '@ngneat/bind-query-params';
import { EmployeeSearchFilter } from '../models/employee-filter.model';
import { TranslateModule } from '@ngx-translate/core';

/***
 *  Properties in Params interface should have formControl in FormGroup
 */
interface Params {
  firstName: string;
  lastName: string;
  email: string;
  employeeId: string;
}

@Component({
    selector: 'uw-employee-search-filter',
    templateUrl: './employee-search-filter.component.html',
    styleUrls: ['./employee-search-filter.component.scss'],
    imports: [ReactiveFormsModule, TranslateModule]
})
export class EmployeeSearchFilterComponent {

  @Output()
  search = new EventEmitter<EmployeeSearchFilter>();

  @Output()
  clearFilter = new EventEmitter();

  filterFormGroup!: UntypedFormGroup;
  manager: any = null;

  constructor(private fb: UntypedFormBuilder,
    private factory: BindQueryParamsFactory) {
    this.createForm();
  }

  /**
   *  Intialize fitler Form
   */
  createForm(): void {
    this.filterFormGroup = this.fb.group({
      firstName: ['', { updateOn: 'submit' }],
      lastName: ['', { updateOn: 'submit' }],
      email: ['', { updateOn: 'submit' }],
      employeeId: ['', { updateOn: 'submit' }],
    });
    this.setQueryParamConfiguration();
  }

  /**
   *  This Method configure queryparams types , strategy in case required
   */
  setQueryParamConfiguration(): void {
    this.manager = this.factory
      .create<Params>([
        { queryKey: 'firstName' },
        { queryKey: 'lastName' },
        { queryKey: 'email' },
        { queryKey: 'employeeId' },
      ])
      .connect(this.filterFormGroup);
  }

  onClearFilter() {
    this.filterFormGroup.reset({
      'firstName': '',
      'lastName': '',
      'email': '',
      'employeeId': ''
    });
    this.clearFilter.emit();
  }

}
